"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGelatoRelayERC2771Address = void 0;
const ethers_1 = require("ethers");
const types_1 = require("../lib/erc2771/types");
const isZkSync_1 = require("./isZkSync");
const getGelatoRelayERC2771Address = (payload, config) => {
    const { chainId, type } = payload;
    switch (type) {
        case types_1.ERC2771Type.CallWithSyncFee:
            return (0, isZkSync_1.isZkSync)(chainId)
                ? (0, ethers_1.getAddress)(config.contract.relayERC2771zkSync)
                : (0, ethers_1.getAddress)(config.contract.relayERC2771);
        case types_1.ERC2771Type.SponsoredCall:
            return (0, isZkSync_1.isZkSync)(chainId)
                ? (0, ethers_1.getAddress)(config.contract.relay1BalanceERC2771zkSync)
                : (0, ethers_1.getAddress)(config.contract.relay1BalanceERC2771);
        case types_1.ERC2771Type.ConcurrentCallWithSyncFee:
            return (0, isZkSync_1.isZkSync)(chainId)
                ? (0, ethers_1.getAddress)(config.contract.relayConcurrentERC2771zkSync)
                : (0, ethers_1.getAddress)(config.contract.relayConcurrentERC2771);
        case types_1.ERC2771Type.ConcurrentSponsoredCall:
            return (0, isZkSync_1.isZkSync)(chainId)
                ? (0, ethers_1.getAddress)(config.contract.relay1BalanceConcurrentERC2771zkSync)
                : (0, ethers_1.getAddress)(config.contract.relay1BalanceConcurrentERC2771);
        default:
            // eslint-disable-next-line no-case-declarations
            const _exhaustiveCheck = type;
            return _exhaustiveCheck;
    }
};
exports.getGelatoRelayERC2771Address = getGelatoRelayERC2771Address;
